import { inject, Pipe, PipeTransform } from "@angular/core";
import { TranslocoService } from "@jsverse/transloco";
import { localeForLang } from "./locale";

type DateFormat = "short" | "long" | "dateLong" | "dateShort" | "dateAuto";

const SHORT_DATE_OPTIONS: Intl.DateTimeFormatOptions = {
  day: "numeric",
  month: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
};

const LONG_DATE_OPTIONS: Intl.DateTimeFormatOptions = {
  day: "numeric",
  month: "numeric",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
};

const DATE_ONLY_LONG_OPTIONS: Intl.DateTimeFormatOptions = {
  day: "numeric",
  month: "numeric",
  year: "numeric",
};

const DATE_ONLY_SHORT_OPTIONS: Intl.DateTimeFormatOptions = {
  day: "numeric",
  month: "numeric",
};

@Pipe({
  name: "ranDate",
  standalone: true,
})
export class RanDatePipe implements PipeTransform {
  private _translocoService = inject(TranslocoService);

  transform(value: Date | null | undefined, format: DateFormat = "short"): string {
    if (!value) {
      return "";
    }

    const locale = localeForLang(this._translocoService.getActiveLang());

    switch (format) {
      case "long":
        return value.toLocaleString(locale, LONG_DATE_OPTIONS);
      case "dateLong":
        return value.toLocaleString(locale, DATE_ONLY_LONG_OPTIONS);
      case "dateShort":
        return value.toLocaleString(locale, DATE_ONLY_SHORT_OPTIONS);
      case "dateAuto": {
        const currentYear = new Date().getFullYear();
        const dateYear = value.getFullYear();
        return value.toLocaleString(
          locale,
          dateYear === currentYear ? DATE_ONLY_SHORT_OPTIONS : DATE_ONLY_LONG_OPTIONS,
        );
      }
      case "short":
      default:
        return value.toLocaleString(locale, SHORT_DATE_OPTIONS);
    }
  }
}
